
import { defineComponent } from 'vue'
import { iLov } from '../../LovsManagement'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import lovsManagementDetailCardValidation from './LovsManagementDetailCardValidation.json'
import useValidate from '@vuelidate/core'

export default defineComponent({
    name: 'lovs-management-detail-card',
    components: { Card, Dropdown, KnValidationMessages },
    props: {
        selectedLov: { type: Object },
        lovs: { type: Array, required: true },
        listOfInputTypes: { type: Array }
    },
    emits: ['touched', 'typeChanged'],
    data() {
        return {
            lovsManagementDetailCardValidation,
            lov: {} as iLov,
            v$: useValidate() as any
        }
    },
    validations() {
        const customValidators: ICustomValidatorMap = {
            'custom-unique-label': (value: string) => {
                return this.fieldNotUnique(value, 'label')
            },
            'custom-unique-name': (value: string) => {
                return this.fieldNotUnique(value, 'name')
            }
        }

        const validationObject = {
            lov: createValidations('lov', lovsManagementDetailCardValidation.validations.lov, customValidators)
        }

        return validationObject
    },
    watch: {
        selectedLov() {
            this.loadLov()
        }
    },
    async created() {
        this.loadLov()
    },
    methods: {
        loadLov() {
            this.lov = this.selectedLov as iLov
        },
        fieldNotUnique(value: string, field: string) {
            const index = this.lovs.findIndex((lov: any) => lov[field] === value && lov.id != this.lov.id)
            return index === -1
        },
        typeChanged() {
            this.$emit('touched')
            this.$emit('typeChanged')
        }
    }
})
